import React from "react"
import styled from "styled-components"

import FormatMessage, {FormattedCurrency, FormattedDate} from "@irati/utils/lang"
import {RewardOrder, User} from "@irati/types"
import {Para} from "@irati/ui/src/Labels"

const Flex = styled.div`
  display: flex;
  flex-direction: column;
`
const RewardFlex = styled.div`
  display: flex;
  max-height: 100px;
  flex-direction: column;
`

const StyledPara = styled(Para)`
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
`

const columns = (formatMessage: FormatMessage) => [
  {
    Header: formatMessage({id: "admin.reporting.rewardOrders.orderId"}),
    id: "uuid",
    minWidth: 120,
    accessor: ({uuid}: RewardOrder) => <StyledPara>{uuid}</StyledPara>
  },
  {
    Header: formatMessage({id: "admin.reporting.rewardOrders.senderHeading"}),
    id: "sender",
    minWidth: 120,
    accessor: ({createdBy}: RewardOrder) => <StyledPara>{createdBy.email}</StyledPara>
  },
  {
    Header: formatMessage({id: "admin.reporting.rewardOrders.receiversHeading"}),
    id: "recipients",
    minWidth: 120,
    accessor: ({recipients}: RewardOrder) => (
      <Flex>
        {recipients.results.map((recipient: User, i) => (
          <StyledPara key={i}>{recipient?.email}</StyledPara>
        ))}
      </Flex>
    )
  },
  {
    Header: formatMessage({id: "admin.reporting.rewardOrders.rewardDetail"}),
    id: "rewards",
    minWidth: 120,
    accessor: ({reward, custom}: RewardOrder) => (
      <RewardFlex>
        <StyledPara>{reward ? reward.header : custom}</StyledPara>
      </RewardFlex>
    )
  },
  {
    Header: formatMessage({id: "admin.reporting.rewardOrders.quantity"}),
    id: "quantity",
    maxWidth: 60,
    accessor: ({quantity}: RewardOrder) => <StyledPara>{quantity}</StyledPara>,
    style: {maxWidth: 60}
  },
  {
    Header: formatMessage({id: "admin.reporting.rewardOrders.totalCost"}),
    id: "totalCost",
    maxWidth: 120,
    accessor: ({costTotal}: RewardOrder) => {
      if (!costTotal) {
        return null
      }
      return <FormattedCurrency isCents={false} currency={costTotal.currency} value={costTotal.amount} />
    },
    style: {maxWidth: 120}
  },
  {
    Header: formatMessage({id: "admin.reporting.rewardOrders.purchaseDate"}),
    id: "updatedAt",
    maxWidth: 120,
    accessor: ({updatedAt}: RewardOrder) => <FormattedDate value={updatedAt} />,
    style: {maxWidth: 120}
  }
]
export default columns
